// Check that the input does not contain any numerics or special characters other than space, hyphen or apostrophe
const restrictedTextInputValidation = value => {
	if (value !== undefined) {
		const regex = /^[A-Za-z \-']*$/;
		const isValid = regex.test(value);
		if (!isValid) {
			return `A valid name cannot include anything other than a letter, space, hyphen or apostrophe`;
		}
	}
	return undefined;
};

export default restrictedTextInputValidation;
